import { Box, Flex, Grid } from 'components/box';
import { Text } from 'components/typography';
import PayFlex from 'icons/payment-methods/payflex-bg.png';
import { css } from '@emotion/react';
import dynamic from 'next/dynamic';

const Modal = dynamic(
  () => import('components/_shared/widgets/modal/with-close')
);

const PayflexInstalmentsModal = ({
  close,
  isOpen,
}: {
  close: () => void;
  isOpen: boolean;
}) => (
  <Modal
    title="Buy Now, Pay Later with Payflex"
    close={close}
    isOpen={isOpen}
    iconSize={20}
    size="medium"
  >
    <Grid fontSize={2} lineHeight={1.5} color="darkGrey">
      <Flex justifyContent={['center', null, 'start']}>
        <img src={PayFlex.src} title="Payflex Logo" alt="Payflex Logo" />
      </Flex>

      <Text fontWeight="bold">
        No interest, no fees, 4x instalments over 6 weeks
      </Text>

      <Box>
        <Text fontWeight="bold">How it works</Text>
        <Text>
          Payflex lets you get what you need now, but pay for it over four
          interest-free instalments. You pay 25% upfront, then three payments of
          25% over the following six weeks.
        </Text>
      </Box>

      <ol
        css={theme => css`
          font-family: ${theme.fonts.body};
          list-style-type: decimal;
          padding-inline-start: 20px;
        `}
      >
        <li>Shop Online and fill your cart</li>
        <li>Choose Payflex at checkout</li>
        <li>Get approved and pay 25% today with your debit or credit card.</li>
        <li>Pay the remainder over 6-weeks. No interest. No fees.</li>
      </ol>

      <Box>
        <Text fontWeight="bold">Please note</Text>
        <ul
          css={theme => css`
            font-family: ${theme.fonts.body};
            list-style-type: disc;
            padding-inline-start: 24px;
            text-indent: -4px;
          `}
        >
          <li>You must be 18 years or older</li>
          <li>You must have a valid South African ID</li>
          <li>
            You must have a debit or credit card issued by Mastercard, Visa, or
            Amex.
          </li>
        </ul>
      </Box>
    </Grid>
  </Modal>
);

export default PayflexInstalmentsModal;
